module.exports = __webpack_public_path__ + "img/Ventas01.35fead4b.png";